// extracted by mini-css-extract-plugin
export default {"customBtn":"CustomButton_customBtn__+2Tii","defaultPrimary":"CustomButton_defaultPrimary__5VnC0","defaultSecondary":"CustomButton_defaultSecondary__6-ycP"};